import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'

import { BMApiService } from '../../../services/bm.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { HttpClient } from '@angular/common/http';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange,
  OnEventArgs
} from 'angular-slickgrid';
import html2pdf from 'html2pdf.js';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, bmdashboardFilterValue, year, benchmarkkpi } from '../../../models/slakpi';
import { division, department, performancemaster } from '../../../models/admin';
//import { EChartOption } from 'echarts';

declare var google: any;
@Component({
  selector: 'app-bench-mark-dashboard',
  templateUrl: './bench-mark-dashboard.component.html',
  styleUrls: ['./bench-mark-dashboard.component.css']
})
export class BenchMarkDashboardComponent implements OnInit {
  strCurrentYear: any = (new Date()).getFullYear();
  chartOptionbenchmarkincomingoutgoingchart1: any = {};
  chartOptionbenchmarkincomingoutgoingchart2: any = {};
  public gridApi;
  public gridColumnApi;

  public columnDefs;
  public defaultColDef;
  public rowData: [];
  public businessDivisionUno: any;
  public selectedDivision: string = '';
  public businessDeptUno: any;
  public trendUno: any;
  public yearUno: any;
  public division_data: any;
  public department_data: any;
  public trend_data: any;
  public yearData: any;
  public positionTotal: number = 0;
  public count_data: any;
  public position_data: any=[];
  public peer_data: any=[];
  public map_data: any=[];

  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  public isBMChambion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  isPDFExport: boolean = false;
  noDataImg: any;
  tenantUno: any;
  kpi_data: any = [];
  public BMPosition_data: any = [];
    kpiUno: any="";
    positionUno: any;
  gid_data: any = [];

  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  angularGrid: AngularGridInstance;
  loading: boolean = true;
  isShowButton: boolean = false;
  constructor(public restApiBM: BMApiService, public utilityService: UtilityService, private router: Router, public restAdminApi: AdminApiService, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.yearUno = Number(this.user.currentYear);
    this.ValidateUserAccess();

    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
  }

  //Method used To Validate User Permission
  ValidateUserAccess() {

    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;
    // this.CheckUserPermission();
    if (this.user.role == 'BM Champions')
      this.isBMChambion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }


    //if (!this.isAdmin && !this.isBMChambion && !this.isBMTeam && !this.isBMVisitor && !this.isBMAdmin)
    //  this.router.navigateByUrl('/access-denied');


    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Performance Benchmark Dashboard");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };

    this.businessDeptUno = 0;
    this.businessDivisionUno = 0;
    this.trendUno = 0;
    if (this.isBMChambion) {
      this.businessDivisionUno = (this.user.divisionUno != '') ? parseInt(this.user.divisionUno) : 0;
    }
    this.kpiUno = "";
    this.positionUno = 0;
    this.loadFilterValues();
    this.getDivisions();
    this.getDepartments();
    this.getTrend();
    this.getPositionData();
    this.loadBenchMarkKPI();
    this.onLoadDashboard();

  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
     
      {
        id: 'kpiName', name: 'KPI Name', field: 'kpiName', sortable: true, type: FieldType.string, filterable: true, width: 200,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,

        },
        onCellClick: (e: Event, args: OnEventArgs) => {
          
          let data = args.dataContext;
          this.router.navigateByUrl('/benchmarkkpiinfo/' + data.kpiUno);
            return false;
        }
      },
      
      {
        id: 'owner', name: 'KPI Owner', field: 'owner', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'owner', 'owner'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiPosition', name: 'KPI Position', field: 'kpiPosition', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiPosition', 'kpiPosition'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', width: 50, cssClass: 'blue',
        type: FieldType.string, formatter: (row, cell, val, columnDef, data) => { return '<span style="cursor:pointer"><i class="fa fa-line-chart fa-lg"></i></span>'; },
        onCellClick: (e: Event, args: OnEventArgs) => {
          
          let objdata: any = args.dataContext;
          this.router.navigateByUrl('/benchmarkkpiinfo/' + objdata.kpiUno);
          return false;
          
        }
      }
    ]


  }
  loadFilterValues() {
    
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApiBM.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;        
        this.yearData = objdata.list_YearMaster;

        //this.onLoadDashboard();
       
        // this.spinner.hide();
      },
        (error) => {
          //Called when error
         // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID ;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApiBM.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getDepartments() {

    let inpValue = new department();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApiBM.getDepartments(inpValue)
      .subscribe(data => {

        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getTrend() {
    this.trend_data = [
      { trendUno: 1, trendName: 'Achievement' },
      { trendUno: 2, trendName: 'Reduction' }
    ];
  }


  loadBenchMarkKPI() {
    this.spinner.show();
    
    let inpValue = new benchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.frequencyUno =  0;
    inpValue.slaRuleUno = 0;
    inpValue.businessDivisionUno = (typeof this.businessDivisionUno != 'undefined' && this.businessDivisionUno) ? this.businessDivisionUno : 0;
    inpValue.reportingDivisionUno = 0;

    this.restApiBM.getBenchMarkKPIs(inpValue)
      .subscribe(data => {
         
        this.kpi_data = data;
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
       
  }

  //getPositionData() {
    

  //  //this.BMPosition_data = [
  //  //  { text: 'Exceeding Peer', value: 1 },
  //  //  { text: 'Below Peer', value: 2 },
  //  //  { text: 'Top Quartile', value: 3 },
  //  //  { text: 'Median', value: 4 },
  //  //  { text: 'Similar Performance', value: 5 }
  //  //];


  //  this.BMPosition_data = [
  //    { text: 'Exceeding Peer', value: 1 },
  //    { text: 'Below Peer', value: 2 },
  //    { text: 'Bottom Quartile', value: 3 },
  //    { text: 'Median', value: 4 },
  //    { text: 'Top Quartile', value: 7 },
  //    { text: 'Similar Performance', value: 8 },
  //    { text: 'Top Decile', value: 9 },
      

  //  ];
  //}
  getPositionData() {
    this.spinner.show();
    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tableName = 'position';

    this.restAdminApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        
        this.BMPosition_data = data;
        //else if (this.pfmType == "position") {
        //         mockDataset[i] = {
        //           id: this.data[i].id,
        //           titleNameEn: this.data[i].titleNameEn
        //         };
        //       }

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  onchangeYear(e) {

    this.yearUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    this.onLoadDashboard();
  }

  onchangeDivision(e) {
    
    this.businessDivisionUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    this.selectedDivision = (e && e.length > 0 && e[0].value != null) ? e[0].text : '';
    this.onLoadDashboard();
    this.loadBenchMarkKPI();
  }

  onchangeKPIName(e)
  {
    
    let selectedKPI = [];
    for (let item of e) {
      selectedKPI.push(item.value);
    }
    if (selectedKPI.length == 1) {
      this.isShowButton = true;
    }
    else {
      this.isShowButton = false;
    }

    this.kpiUno = (selectedKPI.length == 0) ? "" : selectedKPI.toString();
    this.onLoadDashboard();
  }

  onchangeKPIPosition(e) {

    this.positionUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    this.onLoadDashboard();
  }

  onchangeDepartment(e) {

    this.businessDeptUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    this.onLoadDashboard();
  }
  onchangeTrend(e) {

    this.trendUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    this.onLoadDashboard();
  }

  public onLoadDashboard() {
    this.spinner.show();
    let inpValue = new bmdashboardFilterValue();
    inpValue.yearuno = 0;//this.yearUno;
    inpValue.businessDivisionUno = (typeof this.businessDivisionUno != 'undefined' && this.businessDivisionUno) ? this.businessDivisionUno :0;
    inpValue.positionUno = (typeof this.positionUno != 'undefined' && this.positionUno) ? this.positionUno : 0;
    inpValue.strKPIUno = (typeof this.kpiUno != 'undefined' && this.kpiUno.length>0) ?this.kpiUno:"";    
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    
    this.restApiBM.getBMDashboard(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;
        this.count_data = objdata.countData;
        this.position_data = (objdata.positionData != null) ? objdata.positionData:[];
        this.peer_data = (objdata.peerData != null) ? objdata.peerData : [];
        this.map_data = (objdata.mapData != null) ? objdata.mapData : [];
        this.gid_data = (objdata.gridData != null) ? objdata.gridData : [];
        
        this.positionTotal = 0;
        for (var i = 0; i < this.position_data.length; i++) {
          this.positionTotal += parseInt(this.position_data[i].actualValue);
        }
        for (var i = 0; i < this.peer_data.length; i++) {
          this.positionTotal += parseInt(this.peer_data[i].actualValue);
        }
        

        if (this.position_data.length > 0) {
          setTimeout(() => {
            
            this.benchmarkincomingoutgoingchart1(this.positionTotal);
          }, 100);
        }
        if (this.peer_data.length > 0) {
          setTimeout(() => {
          
            this.benchmarkincomingoutgoingchart2(this.positionTotal);
          }, 100);
        }

        google.charts.load('current', {
          'packages': ['geochart'],
          'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY'
        });
        google.charts.setOnLoadCallback(this.benchmarkincomingoutgoingchartworld);


        const mockDataset = [];
        for (let i = 0; i < this.gid_data.length; i++) {

          mockDataset[i] = {
            id:i+1,
            kpiName: this.gid_data[i].kpiName,
            kpiUno: this.gid_data[i].kpiUno,
            kpiPosition: this.gid_data[i].kpiPosition,
            owner: this.gid_data[i].owner,

          };

        }
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });

  }
  benchmarkincomingoutgoingchart1(positionTotal: any) {
    
    let tempArray = [];
    
    //for (var i = 0; i < this.position_data.length; i++) {
    //  tempArray.push([this.position_data[i].positionName, this.position_data[i].actualValue]);
    //  //tempArray.push([this.position_data[i].positionName, 50]);
    //}
    

    //"top decile"
    var objTopDecile = this.position_data.filter(item => item.id ==9);
    if (objTopDecile.length >0) {
      tempArray.push({ name: objTopDecile[0].positionName, value: objTopDecile[0].actualValue });
      
    }

    //TopQuartile
    var objTopQuartile = this.position_data.filter(item => item.id==7);
    if (objTopQuartile.length >0) {
      tempArray.push({ name: objTopQuartile[0].positionName, value: objTopQuartile[0].actualValue });
     
    }
    //"median"
    var objMedian = this.position_data.filter(item => item.id==4);
    if (objMedian.length >0) {
      tempArray.push({ name: objMedian[0].positionName, value: objMedian[0].actualValue });
      
    }
    //"bottom quartile"
    var objBottomQuartile = this.position_data.filter(item => item.id==3);
    if (objBottomQuartile.length >0) {
      tempArray.push({ name: objBottomQuartile[0].positionName, value: objBottomQuartile[0].actualValue });
      
    }
    
    //const data = google.visualization.arrayToDataTable(tempArray);
    const options = {
    
      pieHole: 0.4,
      fontSize: 15,
      legend: {
        textStyle: {
          fontSize: 12
        },
        position: 'bottom'
      },
      //legend: { position: 'bottom' },
      chartArea: { left: 0, right: 0, top: 0, bottom: 50, width: "100%", height: "100%" },
      //colors: ['#006600', '#339933', '#ffc000', '#c00000'],
      //slices: {
      //  0: { color: '#04bdae' },
      //  1: { color: '#367cd2' },
      //  2: { color: '#404041' },
      //  3: { color: '#68b080' },
      //  4: { color: '#0b937e' },
      //  5: { color: '#d5d5d5' },
      //  6: { color: '#fcba03' },
      //  7: { color: '#07db0a' },
      //  8: { color: '#04d4bb' }
      //}
    };

    //echarts starts
    this.chartOptionbenchmarkincomingoutgoingchart1 = {
      tooltip: {
        trigger: "item",
        //formatter: "{c}",
        formatter: function (d) {
          return Math.round((d.value / positionTotal) * 100) + '%';
        },
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#E74C3C', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      legend: {
        bottom: '0',
        left: 'center'
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['30%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return Math.round((d.value / positionTotal) * 100) + '%';
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },
          data: tempArray
        }
      ]
    };
   // echarts ends

    //const chart = new google.visualization.PieChart(document.getElementById('benchmarkincomingoutgoingchart1'));
    //chart.draw(data, options);
  }

    




  benchmarkincomingoutgoingchart2(positionTotal:any) {
    
    let tempArray = [];
    //for (var i = 0; i < this.peer_data.length; i++) {
    //  tempArray.push([this.peer_data[i].peerName, this.peer_data[i].actualValue]);
    //  //tempArray.push([this.peer_data[i].peerName, 10]);
    //}
    let totalval = 0;

    //"exceeding peer"
    var objExceedingPeer = this.peer_data.filter(item => item.id==1);
    if (objExceedingPeer.length >0) {
      tempArray.push({ name: objExceedingPeer[0].peerName, value: objExceedingPeer[0].actualValue });
      totalval += objExceedingPeer[0].actualValue;
    }

    

    //item.peerName.toLowerCase() == "similar performance"
    var objSimilarPerformance = this.peer_data.filter(item => item.id==8);
    if (objSimilarPerformance.length >0) {
      tempArray.push({ name: objSimilarPerformance[0].peerName, value: objSimilarPerformance[0].actualValue });
      totalval += objSimilarPerformance[0].actualValue;
    }
    //"below peer"
    var objBelowPeer = this.peer_data.filter(item => item.id == 2);
    if (objBelowPeer.length > 0) {
      tempArray.push({ name: objBelowPeer[0].peerName, value: objBelowPeer[0].actualValue });
      totalval += objBelowPeer[0].actualValue;
    }
   // const data = google.visualization.arrayToDataTable(tempArray);

    const options = {
    
      pieHole: 0.4,
      fontSize: 15,
      legend: {
        textStyle: {
          fontSize: 12
        },
        position: 'bottom'
      },
      //legend: { position: 'bottom' },
      chartArea: { left: 0, right: 0, top: 0, bottom: 50, width: "100%", height: "100%" },
      //colors: ['#339966', '#ffff00', '#ff0000'],
      //slices: {
      //  0: { color: '#04bdae' },
      //  1: { color: '#367cd2' },
      //  2: { color: '#404041' },
      //  3: { color: '#68b080' },
      //  4: { color: '#0b937e' },
      //  5: { color: '#d5d5d5' },
      //  6: { color: '#fcba03' },
      //  7: { color: '#07db0a' },
      //  8: { color: '#04d4bb' }
      //}
    };

    //echarts starts
    this.chartOptionbenchmarkincomingoutgoingchart2 = {
      tooltip: {
        trigger: "item",
        //formatter: "{c}",
        formatter: function (d) {
          return Math.round((d.value / positionTotal) * 100) + '%';
        },
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },
      legend: {
        bottom: '0',
        left: 'center'
      },
      color: ['#68b097', '#aaebac', '#E74C3C', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['30%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return Math.round((d.value / positionTotal)*100) +'%';
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },
          data:tempArray
        }
      ]
    };
   // echarts ends

    //const chart = new google.visualization.PieChart(document.getElementById('benchmarkincomingoutgoingchart2'));
    //chart.draw(data, options);
  }


  benchmarkincomingoutgoingchartworld = () => {
    
    let tempArray = [['Country', 'Contribution']];
    for (var i = 0; i < this.map_data.length; i++) {
      
      tempArray.push([this.map_data[i].country, parseInt(this.map_data[i].noofPeer)]);
    }
    const data = google.visualization.arrayToDataTable(tempArray);
/*[
      ['Country', 'Popularity'],
      ['Germany', 200],
      ['United States', 300],
      ['Brazil', 400],
      ['Canada', 500],
      ['France', 600],
      ['RU', 700]

    ]*/
    const options = {
      //title: 'DEWA Benchmarking position categories against peers',
      colors: ['#68b097'],
      chartArea: { width: '100%' },
      slices: {
        0: { color: '#68b097' },
        1: { color: '#83ceb1' },
        2: { color: '#aaebac' },
        3: { color: '#f5d17a' },
        4: { color: '#efa96c' },
        5: { color: '#de8060' },
        6: { color: '#a44b2d' },
        7: { color: '#428893' },
        //8: { color: '#04d4bb' }
      }

    };

    const chart = new google.visualization.GeoChart(document.getElementById('benchmarkincomingoutgoingchartworld'));
    chart.draw(data, options);
  }
 

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }
  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  onclickKPI() {
    this.router.navigateByUrl('/benchmarkkpiinfo/' + this.kpiUno);
    return false;
  }

  onclickAllKPI() {
    this.router.navigateByUrl('/benchmarkkpi');
    return false;
  }
  exportToPDF() {
    //this.loading = true;
    var temp = this;
    this.isPDFExport = true;
    this.spinner.show();
    window.scroll(0, 0);
    let data: any;
    


    data = document.getElementById('divBMSection');


    let strDate = new Date().getFullYear() + "" + (new Date().getMonth() + 1) + "" + new Date().getDate();


    var opt = {
      margin: 0.5,
      filename: 'Performance BM Summary_' + strDate + '.pdf',
      //filename: 'Report.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2.4, useCORS: true },
      jsPDF: { unit: 'in', format: 'a2', orientation: 'portrait' }

    };

    // New Promise-based usage:
    //html2pdf().from(data).set(opt).save();
    //hd.style.display = 'block';

    setTimeout(() => {
      //this.loading = false;
      html2pdf().from(data).set(opt).save();
      this.isPDFExport = false;
      temp.spinner.hide();
    }, 300)
  }

 }


